import { PromotionalMessagesUI } from "./PromotionalMessagesUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { promotionalMessagesToShow } from "./promotionalMessagesUtils";
import { hasAnyStock } from "../../utils/product/hasAnyStock";
import { getColourGroupForVariant } from "../../utils/product/getColourGroupForVariant";

export function PromotionalMessages({
  product,
  configProps,
  experiences,
}: Pick<StandardProps, "product" | "configProps" | "experiences">) {
  const { variant, isSelected } = useVariant(product);
  const {
    saveLabels,
    promoTimerVariant,
    newPromoListItem,
    newPromoDrawer,
    oldPromoAccordion,
  } = experiences;

  const messages = promotionalMessagesToShow(
    product,
    variant,
    isSelected,
    saveLabels === "on",
    configProps?.useVariantGroups && product.variantGroups
      ? getColourGroupForVariant(product.variantGroups, variant.id)
      : undefined,
  );

  const hidePromoDrawer =
    typeof configProps?.hidePromoDrawer == "boolean"
      ? configProps.hidePromoDrawer
      : false;

  let countdownTimerAvailabileToOrder = false;

  if (promoTimerVariant !== "Control") {
    const isFullyOutOfStock =
      !hasAnyStock(product) &&
      product.__typename === "SimpleProduct" &&
      product.variants?.length === 1;

    if (!isSelected) {
      countdownTimerAvailabileToOrder = !isFullyOutOfStock;
    } else {
      countdownTimerAvailabileToOrder =
        variant.availability?.availableToOrder || false;
    }
  }

  return (
    <PromotionalMessagesUI
      promotionalMessages={messages}
      hidePromoDrawer={hidePromoDrawer}
      isOldPromoAccordion={oldPromoAccordion === "on"}
      isNewPromoListItem={newPromoListItem === "on"}
      isNewPromoDrawer={newPromoDrawer === "on"}
      countdownTimerVariant={promoTimerVariant as string}
      countdownTimerAvailabileToOrder={countdownTimerAvailabileToOrder}
    />
  );
}
